
export const sortByRank = ({ quantity: rank1 }, { quantity: rank2 }) => {
    if (rank2 > rank1) return +1;
    if (rank1 > rank2) return -1;
    return 0;
};
